import React from "react";
import Spacer from "../Spacer";
import Visibility from "../utils/Visibility";
import { IMG_URl } from "../../common/img_url";
import CirclesMenu from "../MenusElements/CirclesMenu";
import { Header } from "../header";
import { useNavigate } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import { useTranslation } from "react-i18next";
import { Skeleton } from "../ui/skeleton";
import Iterator from "../utils/Iterator";
import BranchModel from "../../Models/BranchModel";
import RestaurantModel from "../../Models/RestaurantModel";

function OldBranchScreen() {
  const { t } = useTranslation();
  const { menus, branch, restaurant, loading, description, name } =
    indexStore();

  const naivgate = useNavigate();

  const onClickMenu = (id: number | string) => {
    naivgate(`${id}`);
  };
  const descriptionKey: keyof BranchModel =
    description === "description_ar" ? "description_ar" : "description_en";
  const formattedDescription = (branch?.[descriptionKey] ?? "").replace(
    /\n/g,
    "<br/>"
  );
  return (
    <>
      <Header noBack={true} />
      <Visibility visible={!loading}>
        <section
          className={`bg-primary p-4 flex  flex-col gap-8 flex-grow text-onPrimary pb-28 `}
        >
          <div className="flex flex-col gap-4 justify-between ">
            <h3 className="uppercase ">
              {restaurant[name as keyof RestaurantModel]}
            </h3>
            {/* <h6 className="branch-name">{branch[description]}</h6> */}
            <h6
              className="leading-6 capitalize text-sm"
              dangerouslySetInnerHTML={{ __html: formattedDescription }}
            ></h6>

            <img
              className="w-28 aspect-square object-contain rounded-lg"
              src={`${IMG_URl}${restaurant.logo}`}
              alt=""
            />
          </div>
          <Visibility visible={menus.length !== 0}>
            <div className="flex flex-col gap-4 ">
              <p className="text-lg ">{t("gloabl.selectMenu")}</p>
              <CirclesMenu
                data={menus}
                displayWaygrid={true}
                onClickMenu={onClickMenu}
              />
            </div>
          </Visibility>
        </section>
      </Visibility>
      <Visibility visible={loading}>
        <RenderLoading />
      </Visibility>
    </>
  );
}

export default OldBranchScreen;
const RenderLoading = () => {
  return (
    <div>
      {/* <Header noBack={true} /> */}
      <div className="flex  p-4 flex-col gap-4 ">
        <Skeleton className="w-40 h-6" />
        <Skeleton className="w-40 h-6" />
        <Skeleton className="w-28 aspect-square" />
        <Spacer height={20} />
        <Skeleton className="w-40 h-6" />

        <Spacer height={20} />
        <div
          className={`grid grid-cols-3  md:grid-cols-3 gap-3 justify-items-center `}
        >
          <Iterator
            data={[1, 2, 3, 4, 5, 6]}
            render={() => <Skeleton className={` w-24 h-24  rounded-full  `} />}
          />
        </div>
      </div>
    </div>
  );
};
